// SPDX-License-Identifier: AGPL-3.0-or-later

export const THE_OTHER_PLATFORM = 'Discord';
